module.exports = __webpack_public_path__ + "media/images/icon__arrow-left--rb-gray@3x-1868a11ece29e84b09207f1b744cbc41.png";